import type { FaireProductEntity } from "../../entity_types/product";

export const p_mxau2n7tg4: FaireProductEntity = {
  token: "p_mxau2n7tg4",
  type: "product",
  name: "Banquet In Castle Jewel Earrings",
  brandToken: "b_eow5j1bbc8",
  brandName: "Ellison+Young",
  imageUrl:
    "https://cdn.faire.com/fastly/c5dab079d7b369d69680d7360dc8f26689807aeddc10a0a1f3a334042962f166.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/81d08da4bd607f06c2802bff020409e3d0c1d1c36d2640afdd6f7e5846e46f6f.jpeg",
    "https://cdn.faire.com/fastly/f9e450de524957d2f8353fb1cf4750ca1c90e25bed56ffb3d6104866be1a29f3.jpeg",
    "https://cdn.faire.com/fastly/274ace8002cd73694d17d5fb0c764f2d911e0ce563fbfb3473cfebf6ce34b2b1.jpeg",
    "https://cdn.faire.com/fastly/889d5dd2d123f9aa90a19b30090945bcee1dad4fd94d9e59c5d69699a215b309.jpeg",
    "https://cdn.faire.com/fastly/6485bec1288cfa5dd3a657b8626bdfdd73d2ce20a44d75a5f5cfc934f7307f65.jpeg",
    "https://cdn.faire.com/fastly/8f3703a89bd621769b636e53ebef63d5333392bdb54b48f6396879234157ea3a.jpeg",
    "https://cdn.faire.com/fastly/25f487fd9791ac67e7a436ff284c9898fb47a45aca1c4cde5e0f9a25f9a0bb9d.jpeg",
    "https://cdn.faire.com/fastly/c5fea6804e784fa25a4b88905f911b49c981b12074de416bdf69b4e8ee5619d1.jpeg",
    "https://cdn.faire.com/fastly/baf37dbc08a970987f9eabc32e7a749f9862fb5cb943fbcf23615fc2527d0a63.jpeg",
    "https://cdn.faire.com/fastly/8308cd20be339ca40505e7a5d192e2291255622d1d200371ae532d033970158a.jpeg",
  ],
  priceDollars: 8.5,
  description:
    "Add a touch of luxury with these glamorous Banquet In Castle Jewel Earrings. Featuring a stunning baguette-cut jewel with a 1-carat round cubic zirconia, these statement earrings will give any outfit the perfect finishing touch. Available in an array of gorgeous colors, you can pick a single pair or collect them all.\n\nDimensions: approximately 1” drop\n\nGold plated Brass, Glass jewels, Cubic Zirconia\n\nLead and Nickel Free",
  tags: [],
  msrpDollars: 21.25,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:19.994Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
